import { ApexOptions } from "apexcharts";
import { ChevronDown, ChevronUp } from "react-feather";
import { Primary, Secondary } from "../../../Constants/Constants";

export const OptionsSalesSummary: ApexOptions = {
  series: [
    {
      name: "Activity",
      data: [42, 44, 55, 66, 55, 86, 52, 44, 44, 66, 55, 86, 52, 44, 44],
    },
  ],
  chart: {
    height: 100,
    type: "bar",
    toolbar: {
      show: false,
    },
    sparkline: {
      enabled: true,
    },
  },
  plotOptions: {
    bar: {
      distributed: true,
      borderRadius: 3,
      columnWidth: "40%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
  },
  legend: {
    show: false,
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  colors: ["#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", Primary, "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff"],
};

export const OfflineChart: ApexOptions = {
  series: [
    {
      name: "Desktops",
      data: [50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62, 35, 35, 35, 66, 66],
    },
  ],
  chart: {
    type: "area",
    offsetY: 30,
    height: 140,
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 5,
      left: 0,
      blur: 2,
      color: Secondary,
      opacity: 0.2,
    },
  },
  colors: ["#EA6F4E"],
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.5,
      opacityTo: 0.1,
      stops: [0, 90, 100],
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  stroke: {
    curve: "straight",
    width: 2,
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 12,
        fillColor: Secondary,
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      },
    ],
  },
};

export const RevenueChart: ApexOptions = {
  series: [
    {
      name: "Desktops",
      data: [15, 14, 11, 20, 10, 15, 11],
    },
  ],
  chart: {
    type: "area",
    height: 123,
    offsetY: 10,
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 5,
      left: 0,
      blur: 2,
      color: "#58b232",
      opacity: 0.2,
    },
  },
  colors: ["#58b232"],
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.6,
      opacityTo: 0.2,
      stops: [0, 100, 100],
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 3,
        fillColor: "#58b232",
        strokeColor: "#fff",
        size: 6,
        shape: "circle",
      },
    ],
  },
};

export const OptionsRevenueOrder: ApexOptions = {
  series: [
    {
      name: "Earning",
      type: "line",
      data: [330, 60, 370, 240, 250, 70, 280, 60, 185, 60],
    },
    {
      name: "Order",
      type: "line",
      data: [70, 330, 60, 200, 100, 250, 100, 350, 110, 300],
    },
  ],
  chart: {
    height: 304,
    type: "line",
    stacked: false,
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 2,
      left: 0,
      blur: 4,
      color: "#000",
      opacity: 0.08,
    },
  },
  stroke: {
    width: [2, 2, 2],
    curve: "smooth",
  },
  grid: {
    show: false,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  plotOptions: {
    bar: {
      columnWidth: "20%",
    },
  },
  colors: [Primary, Secondary],
  fill: {
    opacity: 1,
    type: "solid",
  },
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
  xaxis: {
    type: "category",
    tickAmount: 8,
    tickPlacement: "between",
    tooltip: {
      enabled: false,
    },
    axisBorder: {
      color: "var(--chart-border)",
    },
    axisTicks: {
      show: false,
    },
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 3,
        fillColor: Primary,
        strokeColor: "var(--white)",
        size: 6,
      },
    ],
    hover: {
      size: 6,
      sizeOffset: 0,
    },
  },
  legend: {
    show: false,
  },
  yaxis: {
    min: 0,
    tickAmount: 4,
    labels: {
      formatter: (val) => val + "K",
      offsetX: -5,
    },
  },
  tooltip: {
    shared: false,
    intersect: false,
  },
  responsive: [
    {
      breakpoint: 1400,
      options: {
        chart: {
          height: 174,
        },
      },
    },
    {
      breakpoint: 781,
      options: {
        chart: {
          height: 235,
        },
      },
    },
  ],
};

export const Goal: ApexOptions = {
  series: [80],
  chart: {
    height: 345,
    type: "radialBar",
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    radialBar: {
      startAngle: -135,
      endAngle: 135,
      hollow: {
        size: "78%",
        dropShadow: {
          enabled: false,
        },
      },
      dataLabels: {
        show: true,
        name: {
          show: false,
        },
        value: {
          color: Primary,
          fontSize: "36px",
          fontWeight: "700",
          show: true,
        },
      },
    },
  },
  responsive: [
    {
      breakpoint: 1551,
      options: {
        chart: {
          height: 460,
        },
      },
    },
    {
      breakpoint: 768,
      options: {
        chart: {
          width: 300,
        },
      },
    },
  ],
  colors: [Primary],
  stroke: {
    lineCap: "round",
  },
  tooltip: {
    enabled: false,
  },
};

export const OnlineSalesCardData = [
  { icon: "basket", color: "primary", arrowChart: "arrow-chart-up", arrowColor: "success", title: "Online Sales", endValue: 36256, text: "+5.4%", chart: OptionsSalesSummary },
  { icon: "delivery", color: "secondary", arrowChart: "arrow-chart", arrowColor: "danger", title: "Offline Sales", endValue: 12341, text: "-4.7%", chart: OfflineChart, chartClass: "offline-chart" },
  { icon: "increased", color: "success", arrowChart: "arrow-chart-up", arrowColor: "success", title: "Total Profit", endValue: 85478, text: "+8.2%", chart: RevenueChart, chartClass: "revenue" },
  { icon: "feedback", color: "warning", arrowChart: "arrow-chart", arrowColor: "danger", title: "Response", endValue: 45487, text: "-1.5%" },
];

export const OnlineSalesCardBodyData = ["6.png", "7.png", "8.png", "9.png"];

export const OrdersByCountriesData = [
  { countryCode: "US", productName: "Smart Watch", location: "United States", growthRate: "45.3%", growthDirection: <ChevronUp />, date: "Aug/24", sales: "654k", color: "primary" },
  { countryCode: "BZ", productName: "Night Lamps", location: "Brazil", growthRate: "15.8%", growthDirection: <ChevronDown />, date: "Feb/12", sales: "758k", color: "secondary" },
  { countryCode: "IN", productName: "Fancy Bags", location: "India", growthRate: "35.4%", growthDirection: <ChevronUp />, date: "Jun/11", sales: "165k", color: "primary" },
];

export const TopSellingProductsData = [
  {
    product_image: "dashboard-2/sells/1.png",
    product_name: "Sports Shoes",
    product_id: "#854769",
    date: "25 Mar 2024",
    time: "11:00 AM",
    customer: "Selena Wagner",
    price: "$654.47",
    status: "Succeed",
    color: "success",
  },
  {
    product_image: "dashboard-2/sells/2.png",
    product_name: "Smart Phones",
    product_id: "#348762",
    date: "10 Feb 2024",
    time: "05:00 AM",
    customer: "Walter Renter",
    price: "$345.15",
    status: "Waiting",
    color: "warning",
  },
  {
    product_image: "dashboard-2/sells/3.png",
    product_name: "Waterproof Watch",
    product_id: "#348915",
    date: "14 Aug 2024",
    time: "03:00 AM",
    customer: "Leopold Ebert",
    price: "$345.23",
    status: "Succeed",
    color: "success",
  },
  {
    product_image: "dashboard-2/sells/4.png",
    product_name: "Fancy Bags",
    product_id: "#568395",
    date: "24 Nov 2024",
    time: "04:00 AM",
    customer: "Rachel Ready",
    price: "$736.45",
    status: "Canceled",
    color: "danger",
  },
];

export const CurrentActivityData = [
  {
    date: "10-07-2024",
    time: "Today",
    title: "Updated Report",
    description: "Collect all departments reports from Aria.",
    color: "primary",
  },
  {
    date: "10-07-2024",
    time: "Today",
    title: "Elsa Just like your post",
    description: "Really liked your post about designing and development.",
    color: "secondary",
  },
  {
    date: "10-07-2024",
    time: "Today",
    title: "Anna like your product",
    description: "Your product is just awesome and useful for user.",
    text: "New",
    color: "primary",
  },
  {
    date: "11-07-2024",
    time: "Tomorrow",
    title: "Today Total Sales",
    description: "Listing out all the sales and orders in report.",
    color: "secondary",
  },
];

export const SupportMailboxData = [
  { image: "dashboard-2/user/1.jpg", title: "Emmy Walter", content: "You have opportunity to improve IT abilities and keep with trends.", time: "12 Min ago", color: "primary" },
  { image: "dashboard-2/user/2.jpg", title: "Ava Davis", content: "Reviewing your account activity and taking the necessary precautions.", time: "15 Min ago", color: "secondary" },
  { image: "dashboard-2/user/3.jpg", title: "Carla Blister", content: "Prepare to enjoy the products you have chosen without any hassles.", time: "22 Min ago", color: "primary" },
  { image: "dashboard-2/user/4.jpg", title: "Ralph Edda", content: "For the security of account, your one time password (OTP) is crucial.", time: "25 Min ago", color: "secondary" },
];

export const AddProductCardData = [
  { class: "xl-100 box-col-12", icon: "shopping-bag", color: "primary", title: "Add Product", description: "Easily get inventory by adding products.", header: "Create a new Product", text: "Create", url: "/applications/ecommerce/add_products" },
  { class: "apply-discount", icon: "Product-discount", color: "secondary", title: "Add Discount", description: "Special savings by adding discount.", header: "Apply a new Discount", text: "Apply", url: "/dashboard/default" },
];

export const GoalSummaryData = [
  {title:"Goal Archive",price:"$4,68,258"},
  {title:"Total Goal",price:"$5,25,367"},
  {title:"Duration",price:"6 Months"},
]

const IndiaPosition = { lat: 20.5937, lng: 78.9629 };

export const IndiaMapProps = {
  center: IndiaPosition,
  zoom: 2,
};